import { useMutation } from '@tanstack/react-query';

import type { Persona } from '../../../domain/persona';
import { useUseCases } from '../../../UseCaseProvider';

export const useUpdatePersonaMutation = (onSuccess: () => void) => {
  const { updatePersona } = useUseCases();
  return useMutation({
    mutationKey: ['update-persona'],
    mutationFn: (persona: Persona) => updatePersona(persona),
    onSuccess,
  });
};
